import {
    Dialog,
    DialogTitle,
    DialogContent, 
    DialogActions,  
    Button,
    Typography,
  } from '@material-ui/core';
import {
    WarningRounded as WarningIcon,
} from '@material-ui/icons'
import { useTheme } from '@material-ui/core/styles'
import { withTranslation } from "react-i18next";

import IconButton from '../../atoms/inputs/iconButton'

  
const TransferToSkillErroModel = ({
    msg=[],
    isOpen,
    handleClickCloseModalRequest,    
    t,
  }) => {    
    
    const theme = useTheme()
   
    return (
      <>
        <Dialog
            fullWidth
            maxWidth="xs"
            open={isOpen}
            onClose={handleClickCloseModalRequest}
            aria-labelledby="form-dialog-title"
        >       
          <DialogTitle id="form-dialog-title">
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >                
              <div>
              <IconButton
                  onClick={handleClickCloseModalRequest}
                  style={{ color: theme.palette.iconWarning.color }}
                >
                <WarningIcon fontSize="small" />
              </IconButton>
              {t(`alerts.TransferUnavailable`)}                
              </div>  
                      
            </div>
          </DialogTitle>  
          <DialogContent>            
            {
              msg.map((text, idx)=> (
                  <Typography>
                    {text}
                  </Typography>
              ))
            }   
           </DialogContent>
           <DialogActions>
            <Button
              size="large"
              color="primary"
              variant="contained"
              onClick={handleClickCloseModalRequest}            
            >
              {t(`commons.close`)}
            </Button>
           </DialogActions>                
        </Dialog>       
      </>
    );
  };
  
export default withTranslation()(TransferToSkillErroModel);
  